import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import { TourChainStep } from './checklist-tour-steps.util';

export const getEmbedInsightsTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    switch (taskId) {
        case OnboardingEventId.EMBED_INSIGHTS_LEARN_AND_BUILD:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_go_to_playground_button"]',
                            title: t('sparkflow.learn_and_build.step1.title'),
                            content: t('sparkflow.learn_and_build.step1.body'),
                            disableBeacon: true,
                            placement: 'right',
                        },
                        {
                            target: '[data-tour-id="tour_side-nav-rest-api"]',
                            title: t('sparkflow.learn_and_build.step2.title'),
                            content: t('sparkflow.learn_and_build.step2.body'),
                            disableBeacon: true,
                            placement: 'right',
                        },
                        {
                            target:
                                '[data-tour-id="tour_side-nav-customizations"]',
                            title: t('sparkflow.learn_and_build.step3.title'),
                            content: t('sparkflow.learn_and_build.step3.body'),
                            disableBeacon: true,
                            placement: 'right',
                        },
                        {
                            target:
                                '[data-tour-id="tour_social-links-container"]',
                            title: t('sparkflow.learn_and_build.step4.title'),
                            content: t('sparkflow.learn_and_build.step4.body'),
                            disableBeacon: true,
                            placement: 'top',
                        },
                    ],
                    onCompleteEventId:
                        OnboardingEventId.EMBED_INSIGHTS_LEARN_AND_BUILD,
                },
            ];

        case OnboardingEventId.EMBED_INSIGHTS_SETUP_SECURITY:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_edit-settings-button"]',
                            title: t('sparkflow.setup_security.step1.title'),
                            content: t('sparkflow.setup_security.step1.body'),
                            disableBeacon: true,
                            placement: 'left',
                        },
                    ],
                    onCompleteEventId:
                        OnboardingEventId.EMBED_INSIGHTS_SETUP_SECURITY,
                },
            ];

        default:
            return null;
    }
};
